import LetterBlock from 'components/UI/LetterBlock/LetterBlock';
import React from 'react';
import MultiKeyboardBlocks from '../MultiKeyboardBlocks/MultiKeyboardBlocks';
import './SoundTypes.module.scss';

export default function Consonants() {
    return (
        <div styleName="grid-wrapper ">
            <div styleName="row">
                <LetterBlock letter="b" soundType="consonant" />
                <LetterBlock letter="c" soundType="consonant" />
                <LetterBlock letter="d" soundType="consonant" />
                <LetterBlock letter="f" soundType="consonant" />
                <LetterBlock letter="g" soundType="consonant" />
                <LetterBlock letter="h" soundType="consonant" />
                <LetterBlock letter="j" soundType="consonant" />
            </div>
            <div styleName="row">
                <LetterBlock letter="k" soundType="consonant" />
                <LetterBlock letter="l" soundType="consonant" />
                <LetterBlock letter="m" soundType="consonant" />
                <LetterBlock letter="n" soundType="consonant" />
                <LetterBlock letter="p" soundType="consonant" />
                <LetterBlock letter="q" soundType="consonant" />
                <LetterBlock letter="r" soundType="consonant" />
            </div>
            <div styleName="row">
                <LetterBlock letter="s" soundType="consonant" />
                <LetterBlock letter="t" soundType="consonant" />
                <LetterBlock letter="v" soundType="consonant" />
                <LetterBlock letter="w" soundType="consonant" />
                <LetterBlock letter="x" soundType="consonant" />
                <LetterBlock letter="z" soundType="consonant" />
            </div>
            <div styleName="row">
                <MultiKeyboardBlocks letters="ng">
                    <LetterBlock letter="n" soundType="consonant" />
                    <LetterBlock letter="g" soundType="consonant" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="nk">
                    <LetterBlock letter="n" soundType="consonant" />
                    <LetterBlock letter="k" soundType="consonant" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="ch">
                    <LetterBlock letter="c" soundType="consonant" />
                    <LetterBlock letter="h" soundType="consonant" />
                </MultiKeyboardBlocks>
            </div>
        </div>
    );
}
